// extracted by mini-css-extract-plugin
export default {"logoBox":"GoHomeButton_logoBox__Tjw-1","imgBox":"GoHomeButton_imgBox__Npweh","logo":"GoHomeButton_logo__HNlXI","titleLogo":"GoHomeButton_titleLogo__Lfl9y"};